import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'data-fetching-client';
import {
  View,
  ViewColumn,
  ViewNamespaceType,
  ViewState,
} from '../../viewsSearch/types/ViewTypes';
import { SingleViewByIdQuery } from './useFetchSingleView';

const UPDATE_SINGLE_DEFAULT_VIEW_MUTATION_NAME =
  'updateSingleDefaultView' as const;

export type UpdateSingleDefaultViewInput = {
  id: string;
  objectTypeId: string;
  columns: ViewColumn[];
  state: ViewState;
  namespaceName: ViewNamespaceType;
};

const updateSingleDefaultViewArgs: (keyof UpdateSingleDefaultViewInput)[] = [
  'id',
  'objectTypeId',
  'columns',
  'state',
  'namespaceName',
];

export const UpdateSingleDefaultViewMutation = registerMutation<
  typeof UPDATE_SINGLE_DEFAULT_VIEW_MUTATION_NAME,
  UpdateSingleDefaultViewInput,
  unknown
>({
  fieldName: UPDATE_SINGLE_DEFAULT_VIEW_MUTATION_NAME,
  args: updateSingleDefaultViewArgs,
  fetcher: (args) =>
    http.put(
      `/sales/v3/views/default-view/${args.objectTypeId}/${args.id}?namespace=${args.namespaceName}`,
      {
        data: {
          id: args.id,
          objectTypeId: args.objectTypeId,
          columns: JSON.stringify(args.columns),
          state: JSON.stringify(args.state),
        },
      }
    ),
});

/**
 * Hook for updating HubSpot default views that are saved per-user.
 * Only columns and state are saved for default views - filterGroups and quickFilters are not persisted.
 * @param view The view object containing columns and state to be updated
 * @returns Mutation hook for updating the default view
 */

export const useUpdateSingleDefaultViewMutation = ({
  view,
}: {
  view: View;
}) => {
  return useMutation(UpdateSingleDefaultViewMutation, {
    variables: view,
    refetchQueries: [
      {
        query: SingleViewByIdQuery,
        variables: {
          id: view.id,
          objectTypeId: view.objectTypeId,
          namespaceName: view.namespaceName,
        },
      },
    ],
    awaitRefetchQueries: true,
  });
};
